import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navigation from "./components/feature/Navigation";
import Footer from "./components/feature/Footer";
import { Suspense } from "react";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Navigation />
        <Suspense fallback={<div className="min-h-screen" />}>
          <AppRoutes />
        </Suspense>
        <Footer />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;